<div class="">
  <div class="bg-[var(--tertiary)] py-12">
    <div class="container-padding mx-auto max-w-screen-desktop">
      <h1 class="uppercase text-[var(--beige)] text-[40px]/[40px] font-normal mobile-m:text-left text-center">{{ 'reservations.title' | translate }}</h1>
    </div>
  </div>

  <div>
    <div class="mx-auto max-w-screen-desktop container-padding">
      <h2 class="uppercase text-[25px]/[84px] font-normal mobile-m:text-left text-center">{{ 'reservations.upcoming' | translate }}</h2>
    </div>

    <div *ngIf="isLoadingFutureReservations" class="bg-[var(--light-grey)]">
      <div class="mx-auto max-w-screen-desktop container-padding">
        <div class="flex flex-col gap-6 py-8">
          <app-skeleton dimensions="w-full h-[120px] rounded-2xl"></app-skeleton>
          <app-skeleton dimensions="w-full h-[120px] rounded-2xl"></app-skeleton>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoadingFutureReservations && futureReservations.length > 0" class="bg-[var(--light-grey)] py-8">
      <div class="mx-auto max-w-screen-desktop container-padding flex flex-col gap-6">
        <app-reservation-card *ngFor="let reservation of futureReservations" [reservation]="reservation" [goToReservation]="goToReservation.bind(this)"></app-reservation-card>
      </div>
    </div>
    <div *ngIf="!isLoadingFutureReservations && futureReservations.length === 0" class="mx-auto max-w-screen-desktop container-padding pb-12">
      <div class="mb-4 text-[var(--dark-grey)]">{{ 'reservations.noUpcoming' | translate }}</div>
      <app-button [function]="goToEvents.bind(this)" [text]="'reservations.exploreEvents' | translate"></app-button>
    </div>
  </div>

  <div class="pt-8">
    <div class="">
      <div class="mx-auto max-w-screen-desktop container-padding">
        <h2 class="uppercase text-[25px]/[84px] font-normal mobile-m:text-left text-center text-[var(--dark-grey)]">{{ 'reservations.past' | translate }}</h2>
      </div>
    </div>

    <div *ngIf="isLoadingPastReservations" class="bg-[var(--light-grey)]">
      <div class="mx-auto max-w-screen-desktop container-padding">
        <div class="flex flex-col gap-6 py-8">
          <app-skeleton dimensions="w-full h-[120px] rounded-2xl"></app-skeleton>
          <app-skeleton dimensions="w-full h-[120px] rounded-2xl"></app-skeleton>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoadingPastReservations && pastReservations.length > 0" class="bg-[var(--light-grey)] py-8">
      <div class="mx-auto max-w-screen-desktop container-padding flex flex-col gap-6">
        <app-reservation-card *ngFor="let reservation of pastReservations" [reservation]="reservation" [isPast]="true" [goToReservation]="goToReservation.bind(this)"></app-reservation-card>
      </div>
    </div>
    <div *ngIf="!isLoadingPastReservations && pastReservations.length === 0" class="mx-auto max-w-screen-desktop container-padding pb-12">
      <div class="text-[var(--dark-grey)]">{{ 'reservations.noPast' | translate }}</div>
    </div>
  </div>
</div>
